import { i18n } from "@/main";

/**
 * Typy zdarzeń historii aktywności użytkowników.
 *
 * `eventType` z API (1–9) → klucz logiczny zdarzenia. Etykieta jest **zawsze** liczona
 * przez i18n (`activity-event-<klucz>`), a nie trzymana jako gotowy tekst — dzięki temu
 * zmiana języka od razu przestawia opisy zdarzeń (wcześniej były wpisane po polsku).
 */
export const USER_ACTIVITY_EVENT_KEYS = {
  1: "login-www",
  2: "login-preselection",
  3: "vms-session",
  4: "archive-search-save",
  5: "report-download",
  6: "user-add",
  7: "user-delete",
  8: "permission-grant",
  9: "permission-revoke",
};

/**
 * @param {number|string} eventType Identyfikator typu zdarzenia z API.
 * @returns {string|null} Klucz logiczny zdarzenia albo null, gdy typ jest nieznany.
 */
export function userActivityEventKey(eventType) {
  return USER_ACTIVITY_EVENT_KEYS[Number(eventType)] ?? null;
}

/**
 * @param {number|string} eventType Identyfikator typu zdarzenia z API.
 * @returns {string} Przetłumaczona nazwa zdarzenia w aktualnym języku.
 */
export function userActivityEventLabel(eventType) {
  const key = userActivityEventKey(eventType);

  return key
    ? i18n.global.t(`activity-event-${key}`)
    : i18n.global.t("activity-event-unknown");
}
